var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-3"},[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":"","size":"4x","color":"#03a9f4e8"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }